import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const updatePerVisitEcrfBlocksMutation = async ({ visitId, ecrf_blocks, isAllEcrfBlocks }) => {
  const token = localStorage.getItem("token");

  const payload = {
    ecrf_blocks: ecrf_blocks,
  };
  if (isAllEcrfBlocks !== undefined) payload.is_all_ecrf_blocks = isAllEcrfBlocks;

  const URL = `${__API_URL__}/api/ecrf/update_ecrf_blocks_per_visit/${visitId}/`;

  const response = await axios.patch(URL, payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useUpdatePerVisitEcrfBlocksMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePerVisitEcrfBlocksMutation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["ecrf_blocks_per_visit"] });
      queryClient.invalidateQueries({ queryKey: ["trial_distinct_forms"] });
    },
  });
};

export default useUpdatePerVisitEcrfBlocksMutation;
